import FakeButton from "../../../Components/FormComponents/FakeButton";
import styles from "./index.module.css";
import Texture from "../../MainPage/PriceBlock/texture2.jpg";
import Logo from "../../../Components/Logo";
import { useContext } from "react";
import getLevelInfo from "../helpers";
import UserContext from "../../../store/UserStore/context";

export default function TitleBlock() {
  const userStore = useContext(UserContext);

  const score = userStore.store.user.testResult;
  return (
    <div
      className={styles.container}
      style={{ backgroundImage: `url(${Texture})` }}
    >
      <Logo white />
      <h1>{getLevelInfo(score)?.level}</h1>
      <h2>intensive course</h2>
      <FakeButton
        className={styles.button}
        onClick={() => {
          const targetElement = document.getElementById("target");

          // Скролимо до елемента з плавним ефектом
          targetElement.scrollIntoView({
            behavior: "smooth",
          });
        }}
      >
        Перейти до оплати
      </FakeButton>
    </div>
  );
}
